let PackagesItem = [
    {
        id: 1,
        trackTitle: "Pro track 🔥",
        trackSubtitle: "for experienced Blockchain developers",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Unlimited Access to VODs',
        trackLink: 'https://geekle.us/ticket/1651734831376x672611031166484500',
    },
    {
        id: 2,
        trackTitle: "Beginner track",
        trackSubtitle: "for Blockchain developers",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Beginner Track',
        trackLink: 'https://geekle.us/ticketfree/1651735224812x578602020979605500',
    },
];

export default PackagesItem;
